<template>

 <div class="col-md-3">
            <div class="sticky-top mb-3">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Draggable Events</h4>
                </div>
                <div class="card-body">
                  <!-- the events -->
              
                  <div id="external-events">
                    <template v-for="event in events" >
                    <div :key="event.id" class="external-event bg-success ui-draggable ui-draggable-handle" style="position: relative;">{{ event.title }}</div>

                    </template>
                    <!-- <div class="external-event bg-success ui-draggable ui-draggable-handle" style="position: relative;">Lunch</div> -->
                    <!-- <div class="external-event bg-warning ui-draggable ui-draggable-handle" style="position: relative;">Go home</div>
                    <div class="external-event bg-info ui-draggable ui-draggable-handle" style="position: relative;">Do homework</div>
                    <div class="external-event bg-primary ui-draggable ui-draggable-handle" style="position: relative;">Work on UI design</div>
                    <div class="external-event bg-danger ui-draggable ui-draggable-handle" style="position: relative;">Sleep tight</div> -->
                    <div class="checkbox">
                      <label for="drop-remove">
                        <input type="checkbox" id="drop-remove">
                        remove after drop
                      </label>
                    </div>
                  </div>
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.card -->
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Create Event</h3>
                </div>
                <div class="card-body">
                  <div class="btn-group" style="width: 100%; margin-bottom: 10px;">
                    <ul class="fc-color-picker" id="color-chooser">
                      <li><a class="text-primary" href="#"><i class="fas fa-square"></i></a></li>
                      <li><a class="text-warning" href="#"><i class="fas fa-square"></i></a></li>
                      <li><a class="text-success" href="#"><i class="fas fa-square"></i></a></li>
                      <li><a class="text-danger" href="#"><i class="fas fa-square"></i></a></li>
                      <li><a class="text-muted" href="#"><i class="fas fa-square"></i></a></li>
                    </ul>
                  </div>
                  <!-- /btn-group -->
                  <div class="input-group">
                    <input id="new-event" v-model="weekendsVisibleCheckbox" type="text" class="form-control" placeholder="Event Title">

                    <div class="input-group-append">
                      <button id="add-new-event" type="button" class="btn btn-primary">Add</button>
                    </div>
                    <!-- /btn-group -->
                  </div>
                  <!-- /input-group -->
                </div>
              </div>
            </div>
          </div>
</template>

<script>
import { format } from 'date-fns'

export default {
  props: {
    events: {
      type: Array,
      required: true
    },
    weekendsVisible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    weekendsVisibleCheckbox: {
      get () {
        return this.weekendsVisible
      },
      set (value) {
        return this.$emit('set-weekends-visible', value)
      }
    }
  },
  methods: {
    isAllDay (event) {
      return (event.allDay !== undefined) ? event.allDay : false
    },
    getFormattedDate (event) {
      const date = event.date || event.start

      if (date === undefined) {
        return ''
      }

      return format(date, 'MMM d, yyyy')
    }
  }
}
</script>

<style scoped>
    .calendar-sidebar {
        width: 300px;
        line-height: 1.5;
        background: #eaf9ff;
        border-right: 1px solid #d3e2e8;
    }

    ul {
        margin: 0;
        padding: 0 0 0 1.5em;
    }

    ul li {
        margin: 1.5em 0;
        padding: 0;
    }

    section {
        padding: 2em;
    }

    h2 {
        margin: 0;
        font-size: 16px;
    }
</style>
